<div class="membership-progress" *ngIf="viewModel$ | async as viewModel">
  <div class="membership-progress-header">
    <span class="membership-progress-tier">{{ viewModel.tierName }}</span>
    <span class="membership-progress-next" *ngIf="viewModel.nextTierName">
      {{ viewModel.pointsToNextTier | number }}
      {{ 'account.membership.points-to' | translate : { fgbdefault: 'points to' } }}
      {{ viewModel.nextTierName }}
    </span>
  </div>

  <div class="membership-progress-bar-track">
    <div class="membership-progress-bar-fill" [style.width.%]="viewModel.progressPercent"></div>
  </div>
</div>
